import rtk, { _ } from 'rtk';
import { createActionsHook } from 'rtk/react';
import { name, getUploadModel } from './constants';
const { createActions, createThunks } = rtk(name);

const uploadActions = createActions({
  selectDeviceId: (deviceId) => _({ deviceId }),
  progress: (requestId, progress) => _({ requestId, progress }),
  uploaded: (requestId, { id }) => _({ requestId, id }),
  clear: (uuid) => _({ uuid }),
});

const uploadApi = createThunks({
  send: (file, { getState, dispatch, requestId }) => {
    const formData = new FormData();
    formData.append('file', file);

    const model = getUploadModel();
    const xhr = new XMLHttpRequest();
    const url = new URL(model.url());
    const token = model.getJWT();
    const authHeader = model.generateAuthHeader(token);

    xhr.open('POST', url);
    xhr.timeout = 30000;
    xhr.setRequestHeader('Authorization', authHeader);

    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable) {
        const ratio = Math.round((e.loaded / e.total) * 100) / 100;
        dispatch(progress(requestId, ratio));
      }
    });

    return new Promise((resolve, reject) => {
      xhr.onload = () => {
        if (xhr.status === 201) {
          const data = JSON.parse(xhr.response);
          dispatch(uploaded(requestId, data));
          const doFetch = async () => {
            const { data: upload } = await model.find(data.id);
            if (upload.metadata.analyzed) {
              resolve(upload);
            } else {
              setTimeout(doFetch, 1000);
            }
          };
          doFetch();
        } else {
          reject(new Error(xhr.statusText || 'Upload failed'));
        }
      };

      // Handle network-level errors
      xhr.onerror = () => {
        reject(new Error('Network error'));
      };

      // Handle timeouts
      xhr.ontimeout = () => {
        reject(new Error('Timed out'));
      };

      xhr.send(formData);
    });
  },
  update: async (upload, { getState, dispatch }) => {},
});

// RTK-AUTOEXPORT
// ---- actions ---------
export const { selectDeviceId, progress, uploaded, clear } = uploadActions;

export const useUploadActions = createActionsHook(uploadActions);
// ---- thunks ---------
export const { send, update } = uploadApi;

export const useUploadApi = createActionsHook(uploadApi);
